import React, { FunctionComponent } from "react";
import useGetExpandedDetailsLocal from "../hooks/useGetExpandedDetailsLocal";
import PreviewVisualizationModal from "../../../components/PreviewVisualizationModal";
import { getClassificationByLabels } from "../../../lib/enums/ThreatStatusEnum";

interface IPreviewAndVisualizationModalContainerProps {
  sha1: string;
  relationshipId?: number;
  sourceId?: number;
  initialRulesetName?: string;
  initialRuleName?: string;
  onHide?: () => void;
  yaraTestRunResultId?: number;
}

const PreviewAndVisualizationModalContainer: FunctionComponent<
  IPreviewAndVisualizationModalContainerProps
> = ({
  sha1,
  relationshipId,
  sourceId,
  initialRulesetName,
  initialRuleName,
  onHide,
  yaraTestRunResultId
}) => {
  const { data } = useGetExpandedDetailsLocal(sha1, sourceId, relationshipId);

  if (data?.sample == null) {
    return null;
  }

  return (
    <PreviewVisualizationModal
      sha1={sha1}
      fileType={data?.sample.file_type}
      fileSubtype={data?.sample.file_subtype}
      typeDisplay={data?.sample.type_display}
      threatStatus={getClassificationByLabels(data?.sample.threat_status)}
      sourceId={sourceId ?? data.source.id}
      relationshipId={relationshipId ?? data.relationship.id}
      initialRulesetName={initialRulesetName}
      initialRuleName={initialRuleName}
      onHide={onHide}
      yaraTestRunResultId={yaraTestRunResultId}
    />
  );
};

export default PreviewAndVisualizationModalContainer;
